import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner, Table } from "react-bootstrap";
import {
  NoDataFoundTable,
  PageLoader,
} from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { useParams } from "react-router";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const PullTMapMetadata = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  getStudyCDISCTMap,
}) => {
  const { studyId } = useParams();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pullLibraryData, setPullLibraryData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const getCDISCTMap = async () => {
    try {
      setLoading(true);
      const data = await cdiscManagementService.getCDISCTMap("active");
      const rows = data?.data || [];
      setPullLibraryData(rows);
      setSelectedRows([]);
      setSelectAll(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (studyId) {
      getCDISCTMap();
    }
  }, [studyId]);

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    if (checked) {
      const allIds = pullLibraryData.map((item) => item.tMapId);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(id);
      const updated = isSelected ? prev.filter((x) => x !== id) : [...prev, id];
      setSelectAll(updated.length === pullLibraryData.length);
      return updated;
    });
  };

  const pullStudyCDISCTMapData = async () => {
    setButtonLoader(true);
    const userData = {
      tMapIds: selectedRows,
      studyId,
    };
    const data = await cdiscManagementService.pullStudyCDISCTMapData(userData);
    if (data?.statusCode === 200) {
      Hide();
      getStudyCDISCTMap();
      getCDISCTMap();
      setSelectedRows([]);
    }
    setButtonLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} style={{ width: 575 }} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        {loading ? (
          <PageLoader />
        ) : pullLibraryData.length === 0 ? (
          <NoDataFoundTable MSG="TMaps data not found!." />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 bg-white">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    <Form.Check
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Domain</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Pattern</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Test CD</th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Test Name</th>
                </tr>
              </thead>
              <tbody>
                {pullLibraryData.map((item) => {
                  const rowId = item.tMapId;
                  return (
                    <tr key={rowId}>
                      <td className="text-center">
                        <Form.Check
                          type="checkbox"
                          checked={selectedRows.includes(rowId)}
                          onChange={() => handleRowSelect(rowId)}
                        />
                      </td>
                      <td>{item.domain}</td>
                      <td>{item.pattern}</td>
                      <td>{item.testCD}</td>
                      <td>{item.testName}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </>
        )}
      </Offcanvas.Body>

      <div className="p-2 border-top text-end">
        <button
          className="updateProfile"
          disabled={buttonLoader || selectedRows.length === 0}
          onClick={pullStudyCDISCTMapData}
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Pulling...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default PullTMapMetadata;
